import { render, staticRenderFns } from "./HotsitePersonTypeFields.vue?vue&type=template&id=0a06b59c&scoped=true"
import script from "./HotsitePersonTypeFields.vue?vue&type=script&lang=js"
export * from "./HotsitePersonTypeFields.vue?vue&type=script&lang=js"
import style0 from "./HotsitePersonTypeFields.vue?vue&type=style&index=0&id=0a06b59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06b59c",
  null
  
)

export default component.exports